import { Routes } from '@angular/router';
import { PARTICIPANT_ROUTE_DATA } from './participant/participant-routes';

export const appRoutes: Routes = [
    // TODO: OUTAGE - disabling all of registration for skinny BFY
    /*{
        path: CONTACT_ROUTE_DATA.CONTACTS_BASE.PATH,
        loadChildren: () => import('./contact/contact.routing'),
        data: { preload: false },
    },
    {
        path: INVITED_ADMIN_ROUTE_DATA.INVITED_ADMIN_BASE.PATH,
        loadChildren: () => import('./invited-admin/invited-admin.routing'),
        data: { preload: false },
    },
    {
        path: INVITED_PERSON_ROUTE_DATA.INVITED_PERSON_BASE.PATH,
        loadChildren: () => import('./invited-person/invited-person.routing'),
        data: { preload: false },
    },
    {
        path: GRANT_ROLES_ROUTE_DATA.BASE.PATH,
        loadChildren: () => import('./grant-roles/grant-roles.routing'),
        data: { preload: false },
    },
    ...LEGACY_TECHNOLOGY_ROUTES,*/
    // while Participant routing is our "main" entry point, the lack of a leading prefix in the routes
    // means the we want other more-specific routes to match first to avoid loading the module unnecessarily
    {
        path: PARTICIPANT_ROUTE_DATA.GETTING_STARTED.PATH,
        loadChildren: () => import('./participant/participant.routing'),
        data: { preload: false },
    },
    {
        path: '**',
        redirectTo: PARTICIPANT_ROUTE_DATA.GETTING_STARTED.PATH,
    },
];
